import React, { useContext, useState, useEffect } from "react";
import LeadDetailReadOnlyContext from "contexts/LeadDetailReadOnlyContext";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import PropTypes from 'prop-types';
import { REPORTING_TIMEZONE } from "helpers/sf_constants";
import 'react-datepicker/dist/react-datepicker.css';
import NumberFormat from "react-number-format";
import { getPrimaryButtonClass } from "helpers/sf_utils";

const LeadDatePicker = (props) => {
    const isReadOnly = useContext(LeadDetailReadOnlyContext) || props?.isReadOnly;

    const [isEditable, setIsEditable] = useState(false);
    const [dob, setDob] = useState(null);
    const [isOpen, setIsOpen] = useState(false)
    const [isMouseDown, setIsMouseDown] = useState(false)

    const filterPassedTime = (time) => {
        const pstDate = new Date(new Date().toLocaleString('en-US', { timeZone: REPORTING_TIMEZONE }))
        const currentDate = pstDate;
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    };

    useEffect(() => {
        if (props?.field) {
            const [year, month, day] = props?.field.split('-');
            setDob(`${month}-${day}-${year}`);
        }
    }, [props.field]);

    const handleOnClickClose = () => {
        setIsOpen(false);
    };

    const toggle = () => setIsOpen(!isOpen);

    if (isReadOnly) {
        return <p className="mb-0 fsnormal text-black me-1">{dob || '--'}</p>;
    }

    return (
        <React.Fragment>
            <UncontrolledDropdown isOpen={isOpen}
                onToggle={(event, isOpen) => {
                    if (!isMouseDown && isOpen) {
                        toggle()
                    } else if (isMouseDown && isOpen) {
                        setIsMouseDown(false);
                    }
                    else if (!isOpen) {
                        setIsMouseDown(false);
                        setIsOpen(true)
                    }
                }}
                onMouseDown={(e) => setIsMouseDown(true)}
                onMouseUp={(e) => setIsMouseDown(false)}>
                <DropdownToggle
                    href="#"
                    className='nav-link py-0 px-0'
                    tag="i"
                >
                    <div className="d-flex" onMouseEnter={(e) => { setIsEditable(true) }} onMouseLeave={(e) => { setIsEditable(false) }}>
                        <p className="mb-0 fsnormal text-black me-1" onMouseEnter={(e) => { setIsEditable(true) }} onMouseLeave={(e) => { setIsEditable(false) }}>
                            {dob || '--'}
                        </p>
                        {isEditable === true ?
                            <i
                                className="font-size-13 mdi mdi-pencil text-success"
                            /> :
                            <div className="edit-hover-class">
                                <a ><i
                                    className="font-size-13 mdi mdi-pencil text-success"
                                />
                                </a>
                            </div>
                        }
                    </div>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                    <DropdownItem className="font-weight-semibold">{props?.title}</DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem text></DropdownItem>
                    <div className="d-flex flex-column">
                        <div className="mx-2 px-1">
                            <NumberFormat
                                className="form-control"
                                format="##-##-####"
                                type="text"
                                mask={['M', 'M', 'D', 'D', 'Y', 'Y', 'Y', 'Y']}
                                placeholder="MM-DD-YYYY"
                                value={dob}
                                onChange={(e) => {
                                    e.persist();
                                    const value = e.target?.value
                                    setDob(value);
                                }}
                            />
                        </div>
                        <div className="d-flex align-items-center ms-auto mt-2 px-2">
                            <button
                                className={`btn btn-sm ${getPrimaryButtonClass()} mx-1`} name="saveName"
                                onClick={() => {
                                    let dobString = null;
                                    if (dob) {
                                        const [month, day, year] = dob.split('-');
                                        dobString = `${day}-${month}-${year}`;
                                    }
                                    props.onSave(dobString);
                                    handleOnClickClose()
                                }}
                            >
                                Save
                            </button>
                            <button className="btn btn-sm btn-light mx-1" name="resetName" onClick={handleOnClickClose}>Cancel</button>
                        </div>
                    </div>
                </DropdownMenu>
            </UncontrolledDropdown>

        </React.Fragment>
    )
}

LeadDatePicker.propTypes = {
    title: PropTypes.any,
    onSave: PropTypes.func,
}

export default LeadDatePicker